import { render, staticRenderFns } from "./Richtext.vue?vue&type=template&id=29f52a6f&scoped=true"
import script from "./Richtext.vue?vue&type=script&lang=js"
export * from "./Richtext.vue?vue&type=script&lang=js"
import style0 from "./Richtext.vue?vue&type=style&index=0&id=29f52a6f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f52a6f",
  null
  
)

export default component.exports